import '@/styles.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from '@/App'
import { I18nProvider } from '@/i18n'

const container = document.getElementById('root')
if (!container) {
    throw new Error('Root element not found')
}

createRoot(container).render(
    <StrictMode>
        <I18nProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </I18nProvider>
    </StrictMode>,
)
